/**
 * 自動生成。直接直さない。
 *
 * 作り直しは apps/client で次を実行する。
 *   bun run scripts/ogp-site/build.ts art glossary
 *
 * 用語集の札と用語の頁に出す「絵だけ」の版 (704x370 の webp)。共有の絵 (OGP) と同じ絵で、字とロゴを外してある。
 * 札に小さく添える版 (128x68) は、同じ場所に <名前>-s.webp で置いてある。
 * 表に無い頁は絵を出さない。
 */
export const GLOSSARY_ART_IMAGES: Record<string, string> = {
  "abstract-class": "/assets/art/glossary/abstract-class.6df02ee318.webp",
  "access-modifier": "/assets/art/glossary/abstract-class.6df02ee318.webp",
  "acid": "/assets/art/glossary/acid.49857c7fd6.webp",
  "activation-bar": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "actor": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "agent-harness": "/assets/art/glossary/agent-harness.8b5a8f1e63.webp",
  "agent-loop": "/assets/art/glossary/agent-loop.89e4cfe716.webp",
  "agent-runtime": "/assets/art/glossary/agent-loop.89e4cfe716.webp",
  "agent-skills": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "aggregate-function": "/assets/art/glossary/acid.49857c7fd6.webp",
  "aggregation": "/assets/art/glossary/acid.49857c7fd6.webp",
  "agile": "/assets/art/glossary/agile.6e72af9c16.webp",
  "ai": "/assets/art/glossary/ai.19ca20ad95.webp",
  "ai-agent": "/assets/art/glossary/agent-harness.8b5a8f1e63.webp",
  "algorithm": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "align-items": "/assets/art/glossary/align-items.5ffe7795f3.webp",
  "alignment": "/assets/art/glossary/align-items.5ffe7795f3.webp",
  "alu": "/assets/art/glossary/alu.8e048bd920.webp",
  "api": "/assets/art/glossary/api.e5b0789b3e.webp",
  "app-use": "/assets/art/glossary/app-use.74585afd51.webp",
  "architecture": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "argument": "/assets/art/glossary/argument.581d46da3f.webp",
  "array": "/assets/art/glossary/array.37407764f5.webp",
  "arrow-function": "/assets/art/glossary/arrow-function.0d549483ef.webp",
  "association": "/assets/art/glossary/abstract-class.6df02ee318.webp",
  "async": "/assets/art/glossary/async.640771f4fc.webp",
  "async-await": "/assets/art/glossary/async.640771f4fc.webp",
  "attribute": "/assets/art/glossary/attribute.b9d297f152.webp",
  "authentication": "/assets/art/glossary/authentication.921981af69.webp",
  "authentication-filter": "/assets/art/glossary/authentication-filter.275dbb350b.webp",
  "authmiddleware": "/assets/art/glossary/authmiddleware.8c5f2f09da.webp",
  "authorization": "/assets/art/glossary/authentication.921981af69.webp",
  "auto-fill": "/assets/art/glossary/align-items.5ffe7795f3.webp",
  "autocommit": "/assets/art/glossary/acid.49857c7fd6.webp",
  "automated-test": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "aws": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "back-propagation": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "backend": "/assets/art/glossary/backend.0e9f42a6e0.webp",
  "bastion-host": "/assets/art/glossary/bastion-host.d968e43381.webp",
  "better-sqlite3": "/assets/art/glossary/app-use.74585afd51.webp",
  "big-o-notation": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "binary-search": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "binary-tree": "/assets/art/glossary/binary-tree.d821ff3886.webp",
  "bit": "/assets/art/glossary/alu.8e048bd920.webp",
  "border-radius": "/assets/art/glossary/border-radius.5eb96532ad.webp",
  "box-model": "/assets/art/glossary/align-items.5ffe7795f3.webp",
  "box-sizing": "/assets/art/glossary/align-items.5ffe7795f3.webp",
  "branch": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "breakpoint": "/assets/art/glossary/breakpoint.6a3edd77a4.webp",
  "broadcast": "/assets/art/glossary/broadcast.552baf5212.webp",
  "browser": "/assets/art/glossary/browser.458bb73002.webp",
  "bubble-sort": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "bucket": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "bucket-policy": "/assets/art/glossary/bucket-policy.a7301f9b43.webp",
  "cache": "/assets/art/glossary/cache.e2767a1b26.webp",
  "callback": "/assets/art/glossary/async.640771f4fc.webp",
  "callback-function": "/assets/art/glossary/async.640771f4fc.webp",
  "camel-case": "/assets/art/glossary/array.37407764f5.webp",
  "cascade": "/assets/art/glossary/border-radius.5eb96532ad.webp",
  "cash-flow": "/assets/art/glossary/agile.6e72af9c16.webp",
  "cast": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "cd": "/assets/art/glossary/cd.b0b2eee179.webp",
  "cdn": "/assets/art/glossary/cdn.3ba4aba57f.webp",
  "chain-of-thought": "/assets/art/glossary/chain-of-thought.a3b3a34e8d.webp",
  "channel": "/assets/art/glossary/channel.d7617d2b58.webp",
  "character-encoding": "/assets/art/glossary/alu.8e048bd920.webp",
  "chatgpt": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "chunk": "/assets/art/glossary/chunk.f73a92ccdb.webp",
  "ci": "/assets/art/glossary/agent-loop.89e4cfe716.webp",
  "ci-cd": "/assets/art/glossary/cdn.3ba4aba57f.webp",
  "cidr": "/assets/art/glossary/cidr.63660745b9.webp",
  "class": "/assets/art/glossary/attribute.b9d297f152.webp",
  "class-diagram": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "class-diagram-2": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "classlist": "/assets/art/glossary/classlist.193c115861.webp",
  "classlist-toggle": "/assets/art/glossary/classlist.193c115861.webp",
  "classname": "/assets/art/glossary/classname.61915cb878.webp",
  "claude-code": "/assets/art/glossary/agent-harness.8b5a8f1e63.webp",
  "clickjacking": "/assets/art/glossary/clickjacking.91f21ff47a.webp",
  "cloud": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "cloudfront": "/assets/art/glossary/cdn.3ba4aba57f.webp",
  "code-block": "/assets/art/glossary/argument.581d46da3f.webp",
  "code-point": "/assets/art/glossary/alu.8e048bd920.webp",
  "code-review": "/assets/art/glossary/code-review.7f94e746e3.webp",
  "codex": "/assets/art/glossary/codex.496695d513.webp",
  "column": "/assets/art/glossary/acid.49857c7fd6.webp",
  "command-line": "/assets/art/glossary/cd.b0b2eee179.webp",
  "command-palette": "/assets/art/glossary/command-palette.f4870c85b0.webp",
  "comment": "/assets/art/glossary/argument.581d46da3f.webp",
  "commit": "/assets/art/glossary/commit.16dbc8117a.webp",
  "commit-db": "/assets/art/glossary/acid.49857c7fd6.webp",
  "comparison-operator": "/assets/art/glossary/comparison-operator.bdb3627a93.webp",
  "compile": "/assets/art/glossary/compile.edf2b2f5cf.webp",
  "complexity": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "component": "/assets/art/glossary/classname.61915cb878.webp",
  "composite-index": "/assets/art/glossary/commit.16dbc8117a.webp",
  "comprehension": "/assets/art/glossary/comprehension.1d60a268b5.webp",
  "conditional": "/assets/art/glossary/comparison-operator.bdb3627a93.webp",
  "conditional-rendering": "/assets/art/glossary/conditional-rendering.042ac0215e.webp",
  "conflict": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "connection-pool": "/assets/art/glossary/connection-pool.0af97e60d2.webp",
  "constructor": "/assets/art/glossary/abstract-class.6df02ee318.webp",
  "container": "/assets/art/glossary/bucket-policy.a7301f9b43.webp",
  "content-type": "/assets/art/glossary/async.640771f4fc.webp",
  "context-engineering": "/assets/art/glossary/agent-harness.8b5a8f1e63.webp",
  "context-length": "/assets/art/glossary/chain-of-thought.a3b3a34e8d.webp",
  "contrast": "/assets/art/glossary/border-radius.5eb96532ad.webp",
  "control-structure": "/assets/art/glossary/argument.581d46da3f.webp",
  "control-unit": "/assets/art/glossary/alu.8e048bd920.webp",
  "convolutional-layer": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "cookie": "/assets/art/glossary/api.e5b0789b3e.webp",
  "cors": "/assets/art/glossary/arrow-function.0d549483ef.webp",
  "cosine-similarity": "/assets/art/glossary/chunk.f73a92ccdb.webp",
  "counter": "/assets/art/glossary/conditional-rendering.042ac0215e.webp",
  "coverage": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "cross-validation": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "csp": "/assets/art/glossary/clickjacking.91f21ff47a.webp",
  "csrf": "/assets/art/glossary/clickjacking.91f21ff47a.webp",
  "css": "/assets/art/glossary/border-radius.5eb96532ad.webp",
  "css-variable": "/assets/art/glossary/align-items.5ffe7795f3.webp",
  "csv-parse": "/assets/art/glossary/csv-parse.0d1381423e.webp",
  "curl": "/assets/art/glossary/cidr.63660745b9.webp",
  "custom-hook": "/assets/art/glossary/custom-hook.d332636224.webp",
  "data-literacy": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "data-structure": "/assets/art/glossary/connection-pool.0af97e60d2.webp",
  "data-type": "/assets/art/glossary/argument.581d46da3f.webp",
  "database": "/assets/art/glossary/acid.49857c7fd6.webp",
  "dataclass": "/assets/art/glossary/attribute.b9d297f152.webp",
  "db-t3-micro": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "deadlock": "/assets/art/glossary/commit.16dbc8117a.webp",
  "debug": "/assets/art/glossary/array.37407764f5.webp",
  "decision": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "decisiontree": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "deep-learning": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "default-argument": "/assets/art/glossary/default-argument.1d2b7e4191.webp",
  "delivery": "/assets/art/glossary/agile.6e72af9c16.webp",
  "dependencies": "/assets/art/glossary/app-use.74585afd51.webp",
  "dependency-array": "/assets/art/glossary/custom-hook.d332636224.webp",
  "dependency-direction": "/assets/art/glossary/dependency-direction.db60ad2d8e.webp",
  "deploy": "/assets/art/glossary/cdn.3ba4aba57f.webp",
  "derived-table": "/assets/art/glossary/acid.49857c7fd6.webp",
  "design": "/assets/art/glossary/commit.16dbc8117a.webp",
  "devdependencies": "/assets/art/glossary/devdependencies.1f8be05b34.webp",
  "directory": "/assets/art/glossary/cd.b0b2eee179.webp",
  "divide-and-conquer": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "do-while": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "docker": "/assets/art/glossary/bucket-policy.a7301f9b43.webp",
  "dockerfile": "/assets/art/glossary/cache.e2767a1b26.webp",
  "dom": "/assets/art/glossary/classlist.193c115861.webp",
  "domain": "/assets/art/glossary/broadcast.552baf5212.webp",
  "draw-io": "/assets/art/glossary/commit.16dbc8117a.webp",
  "dynamic-programming": "/assets/art/glossary/binary-tree.d821ff3886.webp",
  "ecosystem": "/assets/art/glossary/classname.61915cb878.webp",
  "edge-case": "/assets/art/glossary/argument.581d46da3f.webp",
  "embedding": "/assets/art/glossary/chunk.f73a92ccdb.webp",
  "encapsulation": "/assets/art/glossary/abstract-class.6df02ee318.webp",
  "endpoint": "/assets/art/glossary/api.e5b0789b3e.webp",
  "entity": "/assets/art/glossary/commit.16dbc8117a.webp",
  "entry-point": "/assets/art/glossary/app-use.74585afd51.webp",
  "environment-variable": "/assets/art/glossary/authentication-filter.275dbb350b.webp",
  "error-message": "/assets/art/glossary/csv-parse.0d1381423e.webp",
  "escape": "/assets/art/glossary/array.37407764f5.webp",
  "evaluation": "/assets/art/glossary/chain-of-thought.a3b3a34e8d.webp",
  "event": "/assets/art/glossary/classlist.193c115861.webp",
  "event-loop": "/assets/art/glossary/async.640771f4fc.webp",
  "event-preventdefault": "/assets/art/glossary/classlist.193c115861.webp",
  "exception-handling": "/assets/art/glossary/exception-handling.4a4ed8159a.webp",
  "execution-order": "/assets/art/glossary/acid.49857c7fd6.webp",
  "express-js": "/assets/art/glossary/api.e5b0789b3e.webp",
  "express-json": "/assets/art/glossary/api.e5b0789b3e.webp",
  "f-string": "/assets/art/glossary/argument.581d46da3f.webp",
  "fetch-api": "/assets/art/glossary/async.640771f4fc.webp",
  "fetch-api-2": "/assets/art/glossary/async.640771f4fc.webp",
  "few-shot": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "field": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "fine-tuning": "/assets/art/glossary/chunk.f73a92ccdb.webp",
  "flex-wrap": "/assets/art/glossary/align-items.5ffe7795f3.webp",
  "flowchart": "/assets/art/glossary/code-review.7f94e746e3.webp",
  "foreign-key": "/assets/art/glossary/commit.16dbc8117a.webp",
  "form": "/assets/art/glossary/browser.458bb73002.webp",
  "forward-propagation": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "fragment": "/assets/art/glossary/classname.61915cb878.webp",
  "framework": "/assets/art/glossary/dependency-direction.db60ad2d8e.webp",
  "frontend": "/assets/art/glossary/array.37407764f5.webp",
  "full-scan": "/assets/art/glossary/acid.49857c7fd6.webp",
  "fullstack": "/assets/art/glossary/fullstack.cb7714b9f3.webp",
  "function": "/assets/art/glossary/default-argument.1d2b7e4191.webp",
  "function-definition": "/assets/art/glossary/default-argument.1d2b7e4191.webp",
  "functional-dependency": "/assets/art/glossary/commit.16dbc8117a.webp",
  "generative-ai": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "generics": "/assets/art/glossary/generics.662a0e92ff.webp",
  "git": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "git-clone": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "git-pull": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "github": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "graph": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "guardrails": "/assets/art/glossary/agent-harness.8b5a8f1e63.webp",
  "hallucination": "/assets/art/glossary/chain-of-thought.a3b3a34e8d.webp",
  "hash-function": "/assets/art/glossary/alu.8e048bd920.webp",
  "hash-table": "/assets/art/glossary/connection-pool.0af97e60d2.webp",
  "hashing": "/assets/art/glossary/authentication.921981af69.webp",
  "hashmap": "/assets/art/glossary/hashmap.2714910798.webp",
  "hashset": "/assets/art/glossary/hashmap.2714910798.webp",
  "health-check": "/assets/art/glossary/bastion-host.d968e43381.webp",
  "heap": "/assets/art/glossary/connection-pool.0af97e60d2.webp",
  "hosted-zone": "/assets/art/glossary/bucket-policy.a7301f9b43.webp",
  "hot-reload": "/assets/art/glossary/hot-reload.49585d73db.webp",
  "hover": "/assets/art/glossary/border-radius.5eb96532ad.webp",
  "html": "/assets/art/glossary/browser.458bb73002.webp",
  "http": "/assets/art/glossary/broadcast.552baf5212.webp",
  "http-method": "/assets/art/glossary/api.e5b0789b3e.webp",
  "http-request": "/assets/art/glossary/arrow-function.0d549483ef.webp",
  "httpd": "/assets/art/glossary/cache.e2767a1b26.webp",
  "httpsession": "/assets/art/glossary/dependency-direction.db60ad2d8e.webp",
  "human-in-the-loop": "/assets/art/glossary/agent-harness.8b5a8f1e63.webp",
  "hypothesis": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "image": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "immutable": "/assets/art/glossary/array.37407764f5.webp",
  "immutable-update": "/assets/art/glossary/classname.61915cb878.webp",
  "increment": "/assets/art/glossary/compile.edf2b2f5cf.webp",
  "indent": "/assets/art/glossary/argument.581d46da3f.webp",
  "index-db": "/assets/art/glossary/commit.16dbc8117a.webp",
  "indexerror": "/assets/art/glossary/comparison-operator.bdb3627a93.webp",
  "inheritance": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "inline-code": "/assets/art/glossary/code-review.7f94e746e3.webp",
  "innerhtml": "/assets/art/glossary/classlist.193c115861.webp",
  "input-device": "/assets/art/glossary/alu.8e048bd920.webp",
  "instance": "/assets/art/glossary/attribute.b9d297f152.webp",
  "integer-parseint": "/assets/art/glossary/integer-parseint.b3825cf0d4.webp",
  "interface": "/assets/art/glossary/abstract-class.6df02ee318.webp",
  "interface-type": "/assets/art/glossary/abstract-class.6df02ee318.webp",
  "interface-type-2": "/assets/art/glossary/devdependencies.1f8be05b34.webp",
  "internet": "/assets/art/glossary/broadcast.552baf5212.webp",
  "interpreter": "/assets/art/glossary/argument.581d46da3f.webp",
  "io": "/assets/art/glossary/argument.581d46da3f.webp",
  "ioexception": "/assets/art/glossary/exception-handling.4a4ed8159a.webp",
  "iterable": "/assets/art/glossary/iterable.4617ef07e9.webp",
  "iteration": "/assets/art/glossary/default-argument.1d2b7e4191.webp",
  "java": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "javascript": "/assets/art/glossary/array.37407764f5.webp",
  "join": "/assets/art/glossary/join.8afeb587b1.webp",
  "json": "/assets/art/glossary/async.640771f4fc.webp",
  "json-stringify": "/assets/art/glossary/arrow-function.0d549483ef.webp",
  "jsonify": "/assets/art/glossary/api.e5b0789b3e.webp",
  "junction-table": "/assets/art/glossary/commit.16dbc8117a.webp",
  "justify-content": "/assets/art/glossary/align-items.5ffe7795f3.webp",
  "jwt": "/assets/art/glossary/authmiddleware.8c5f2f09da.webp",
  "jwt-sign": "/assets/art/glossary/authmiddleware.8c5f2f09da.webp",
  "jwt-verify": "/assets/art/glossary/authmiddleware.8c5f2f09da.webp",
  "kebab-case": "/assets/art/glossary/border-radius.5eb96532ad.webp",
  "kernel": "/assets/art/glossary/cd.b0b2eee179.webp",
  "key-pair": "/assets/art/glossary/bastion-host.d968e43381.webp",
  "knowledge-cutoff": "/assets/art/glossary/chunk.f73a92ccdb.webp",
  "lambda": "/assets/art/glossary/argument.581d46da3f.webp",
  "latency": "/assets/art/glossary/cidr.63660745b9.webp",
  "layer": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "least-privilege": "/assets/art/glossary/authentication.921981af69.webp",
  "library": "/assets/art/glossary/argument.581d46da3f.webp",
  "linear-search": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "linked-list": "/assets/art/glossary/linked-list.31726e57dc.webp",
  "linux": "/assets/art/glossary/linux.50277968f0.webp",
  "list-comprehension": "/assets/art/glossary/comprehension.1d60a268b5.webp",
  "list-ds": "/assets/art/glossary/list-ds.cbda55d23d.webp",
  "llamaindex": "/assets/art/glossary/chunk.f73a92ccdb.webp",
  "llm": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "loading": "/assets/art/glossary/conditional-rendering.042ac0215e.webp",
  "localstorage": "/assets/art/glossary/array.37407764f5.webp",
  "lock": "/assets/art/glossary/commit.16dbc8117a.webp",
  "logical-operator": "/assets/art/glossary/comparison-operator.bdb3627a93.webp",
  "loop": "/assets/art/glossary/default-argument.1d2b7e4191.webp",
  "machine-learning": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "many-to-many": "/assets/art/glossary/commit.16dbc8117a.webp",
  "max-width": "/assets/art/glossary/max-width.3b9042c5bd.webp",
  "mcp": "/assets/art/glossary/agent-harness.8b5a8f1e63.webp",
  "media-query": "/assets/art/glossary/max-width.3b9042c5bd.webp",
  "memoization": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "memory": "/assets/art/glossary/alu.8e048bd920.webp",
  "merge": "/assets/art/glossary/agent-loop.89e4cfe716.webp",
  "merge-2": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "merge-sort": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "metadata": "/assets/art/glossary/browser.458bb73002.webp",
  "method": "/assets/art/glossary/argument.581d46da3f.webp",
  "method-definition": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "micro-interaction": "/assets/art/glossary/border-radius.5eb96532ad.webp",
  "middleware": "/assets/art/glossary/backend.0e9f42a6e0.webp",
  "missing-value": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "mobile-first": "/assets/art/glossary/max-width.3b9042c5bd.webp",
  "module": "/assets/art/glossary/comprehension.1d60a268b5.webp",
  "modulo-operator": "/assets/art/glossary/argument.581d46da3f.webp",
  "mojibake": "/assets/art/glossary/alu.8e048bd920.webp",
  "multi-stage": "/assets/art/glossary/cache.e2767a1b26.webp",
  "multiplicity": "/assets/art/glossary/commit.16dbc8117a.webp",
  "mutable": "/assets/art/glossary/mutable.f4139baa17.webp",
  "mysql": "/assets/art/glossary/acid.49857c7fd6.webp",
  "mysql2-promise": "/assets/art/glossary/acid.49857c7fd6.webp",
  "neural-network": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "neuron": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "nodejs": "/assets/art/glossary/app-use.74585afd51.webp",
  "non-functional-requirement": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "none": "/assets/art/glossary/argument.581d46da3f.webp",
  "normalization": "/assets/art/glossary/commit.16dbc8117a.webp",
  "nosql": "/assets/art/glossary/connection-pool.0af97e60d2.webp",
  "np-linspace": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "oauth": "/assets/art/glossary/authentication.921981af69.webp",
  "object": "/assets/art/glossary/array.37407764f5.webp",
  "object-key": "/assets/art/glossary/devdependencies.1f8be05b34.webp",
  "observability": "/assets/art/glossary/cache.e2767a1b26.webp",
  "one-way-data-flow": "/assets/art/glossary/one-way-data-flow.9ecaf4ee15.webp",
  "operations-maintenance": "/assets/art/glossary/cd.b0b2eee179.webp",
  "operator": "/assets/art/glossary/comparison-operator.bdb3627a93.webp",
  "orm": "/assets/art/glossary/commit.16dbc8117a.webp",
  "output-device": "/assets/art/glossary/alu.8e048bd920.webp",
  "overfitting": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "overload": "/assets/art/glossary/abstract-class.6df02ee318.webp",
  "override": "/assets/art/glossary/abstract-class.6df02ee318.webp",
  "package-json": "/assets/art/glossary/app-use.74585afd51.webp",
  "package-lock-json": "/assets/art/glossary/classname.61915cb878.webp",
  "pascal-case": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "password": "/assets/art/glossary/authentication.921981af69.webp",
  "pay-as-you-go": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "permission": "/assets/art/glossary/cd.b0b2eee179.webp",
  "pipe": "/assets/art/glossary/linux.50277968f0.webp",
  "placeholder": "/assets/art/glossary/acid.49857c7fd6.webp",
  "platform-independent": "/assets/art/glossary/commit.16dbc8117a.webp",
  "plt-bar": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "plt-figure": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "plt-plot": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "plt-scatter": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "policy": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "polymorphism": "/assets/art/glossary/abstract-class.6df02ee318.webp",
  "pom-xml": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "pooling-layer": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "port-80": "/assets/art/glossary/cidr.63660745b9.webp",
  "port-forwarding": "/assets/art/glossary/cidr.63660745b9.webp",
  "port-number": "/assets/art/glossary/cidr.63660745b9.webp",
  "position": "/assets/art/glossary/align-items.5ffe7795f3.webp",
  "post-redirect-get": "/assets/art/glossary/api.e5b0789b3e.webp",
  "postgresql": "/assets/art/glossary/acid.49857c7fd6.webp",
  "prepared-statement": "/assets/art/glossary/app-use.74585afd51.webp",
  "presentational-component": "/assets/art/glossary/classname.61915cb878.webp",
  "primary-key": "/assets/art/glossary/commit.16dbc8117a.webp",
  "prime-number": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "primitive": "/assets/art/glossary/array.37407764f5.webp",
  "primitive-type": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "private-key": "/assets/art/glossary/authentication.921981af69.webp",
  "process": "/assets/art/glossary/process.267f3e1038.webp",
  "process-flow": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "promise": "/assets/art/glossary/arrow-function.0d549483ef.webp",
  "promise-all": "/assets/art/glossary/async.640771f4fc.webp",
  "prompt": "/assets/art/glossary/chain-of-thought.a3b3a34e8d.webp",
  "prompt-engineering": "/assets/art/glossary/chain-of-thought.a3b3a34e8d.webp",
  "prompttemplate": "/assets/art/glossary/chain-of-thought.a3b3a34e8d.webp",
  "property": "/assets/art/glossary/attribute.b9d297f152.webp",
  "protocol": "/assets/art/glossary/broadcast.552baf5212.webp",
  "pseudo-class": "/assets/art/glossary/border-radius.5eb96532ad.webp",
  "public-key": "/assets/art/glossary/authentication.921981af69.webp",
  "pull-request": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "push": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "python": "/assets/art/glossary/argument.581d46da3f.webp",
  "query": "/assets/art/glossary/acid.49857c7fd6.webp",
  "query-parameter": "/assets/art/glossary/api.e5b0789b3e.webp",
  "queue": "/assets/art/glossary/process.267f3e1038.webp",
  "quick-sort": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "raci": "/assets/art/glossary/agile.6e72af9c16.webp",
  "rag": "/assets/art/glossary/chunk.f73a92ccdb.webp",
  "re-render": "/assets/art/glossary/one-way-data-flow.9ecaf4ee15.webp",
  "react": "/assets/art/glossary/classname.61915cb878.webp",
  "react-reactnode": "/assets/art/glossary/react-reactnode.e84fe794b7.webp",
  "read-replica": "/assets/art/glossary/commit.16dbc8117a.webp",
  "rebase": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "record-db": "/assets/art/glossary/acid.49857c7fd6.webp",
  "recursion": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "redirect": "/assets/art/glossary/redirect.eb05c911f7.webp",
  "reference-type": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "region": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "regression": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "rendering": "/assets/art/glossary/align-items.5ffe7795f3.webp",
  "repetition": "/assets/art/glossary/argument.581d46da3f.webp",
  "repl": "/assets/art/glossary/argument.581d46da3f.webp",
  "repository": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "req-params": "/assets/art/glossary/api.e5b0789b3e.webp",
  "request-body": "/assets/art/glossary/async.640771f4fc.webp",
  "request-header": "/assets/art/glossary/request-header.d42d46f56e.webp",
  "request-scope": "/assets/art/glossary/dependency-direction.db60ad2d8e.webp",
  "requirements-txt": "/assets/art/glossary/default-argument.1d2b7e4191.webp",
  "response-header": "/assets/art/glossary/async.640771f4fc.webp",
  "response-ok": "/assets/art/glossary/async.640771f4fc.webp",
  "responsibility-segregation": "/assets/art/glossary/hot-reload.49585d73db.webp",
  "responsive-design": "/assets/art/glossary/max-width.3b9042c5bd.webp",
  "rest-api": "/assets/art/glossary/api.e5b0789b3e.webp",
  "retrieval": "/assets/art/glossary/chunk.f73a92ccdb.webp",
  "return-value": "/assets/art/glossary/default-argument.1d2b7e4191.webp",
  "review": "/assets/art/glossary/agile.6e72af9c16.webp",
  "rnn-transformer": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "rollback": "/assets/art/glossary/acid.49857c7fd6.webp",
  "root-user": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "router": "/assets/art/glossary/router.3b4faf27bc.webp",
  "routing": "/assets/art/glossary/broadcast.552baf5212.webp",
  "salt": "/assets/art/glossary/app-use.74585afd51.webp",
  "sandbox": "/assets/art/glossary/agent-harness.8b5a8f1e63.webp",
  "schema": "/assets/art/glossary/commit.16dbc8117a.webp",
  "scikit-learn": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "scope": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "security-group": "/assets/art/glossary/bucket-policy.a7301f9b43.webp",
  "seed-data": "/assets/art/glossary/acid.49857c7fd6.webp",
  "selection-sort": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "selector": "/assets/art/glossary/border-radius.5eb96532ad.webp",
  "self-attention": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "semantic-html": "/assets/art/glossary/browser.458bb73002.webp",
  "semantic-tag": "/assets/art/glossary/browser.458bb73002.webp",
  "separation-of-concerns": "/assets/art/glossary/hot-reload.49585d73db.webp",
  "sequence": "/assets/art/glossary/acid.49857c7fd6.webp",
  "sequence-diagram": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "server": "/assets/art/glossary/cache.e2767a1b26.webp",
  "servlet-container": "/assets/art/glossary/dependency-direction.db60ad2d8e.webp",
  "session": "/assets/art/glossary/authentication.921981af69.webp",
  "session-hijacking": "/assets/art/glossary/app-use.74585afd51.webp",
  "session-invalidate": "/assets/art/glossary/dependency-direction.db60ad2d8e.webp",
  "session-scope": "/assets/art/glossary/dependency-direction.db60ad2d8e.webp",
  "session-setattribute": "/assets/art/glossary/generics.662a0e92ff.webp",
  "session-timeout": "/assets/art/glossary/authentication.921981af69.webp",
  "set-ds": "/assets/art/glossary/alu.8e048bd920.webp",
  "setautocommit": "/assets/art/glossary/acid.49857c7fd6.webp",
  "shared-responsibility-model": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "shared-types": "/assets/art/glossary/devdependencies.1f8be05b34.webp",
  "shebang": "/assets/art/glossary/cd.b0b2eee179.webp",
  "shell": "/assets/art/glossary/cd.b0b2eee179.webp",
  "shell-script": "/assets/art/glossary/cd.b0b2eee179.webp",
  "side-effect": "/assets/art/glossary/custom-hook.d332636224.webp",
  "sidebar": "/assets/art/glossary/align-items.5ffe7795f3.webp",
  "sieve-of-eratosthenes": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "signed-url": "/assets/art/glossary/request-header.d42d46f56e.webp",
  "single-thread": "/assets/art/glossary/process.267f3e1038.webp",
  "slack": "/assets/art/glossary/agile.6e72af9c16.webp",
  "slice": "/assets/art/glossary/mutable.f4139baa17.webp",
  "snake-case": "/assets/art/glossary/argument.581d46da3f.webp",
  "sns-boxplot": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "sns-heatmap": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "software-testing": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "spa": "/assets/art/glossary/router.3b4faf27bc.webp",
  "spread": "/assets/art/glossary/array.37407764f5.webp",
  "spread-syntax": "/assets/art/glossary/classname.61915cb878.webp",
  "sql": "/assets/art/glossary/acid.49857c7fd6.webp",
  "ssl-certificate": "/assets/art/glossary/ssl-certificate.c883e08dda.webp",
  "ssl-tls": "/assets/art/glossary/ssl-certificate.c883e08dda.webp",
  "stack": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "stage": "/assets/art/glossary/stage.5810213a83.webp",
  "staging": "/assets/art/glossary/cdn.3ba4aba57f.webp",
  "standard-library": "/assets/art/glossary/argument.581d46da3f.webp",
  "stateless": "/assets/art/glossary/api.e5b0789b3e.webp",
  "static-hosting": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "static-typing": "/assets/art/glossary/devdependencies.1f8be05b34.webp",
  "status-code": "/assets/art/glossary/async.640771f4fc.webp",
  "stock-deduction": "/assets/art/glossary/commit.16dbc8117a.webp",
  "storage": "/assets/art/glossary/aws.8cf585bd1a.webp",
  "storage-device": "/assets/art/glossary/process.267f3e1038.webp",
  "streaming": "/assets/art/glossary/broadcast.552baf5212.webp",
  "string-manipulation": "/assets/art/glossary/comprehension.1d60a268b5.webp",
  "string-valueof": "/assets/art/glossary/cast.c1f9cb7ab1.webp",
  "subnet": "/assets/art/glossary/bucket-policy.a7301f9b43.webp",
  "subquery": "/assets/art/glossary/acid.49857c7fd6.webp",
  "supervised-learning": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "swimlane": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "sync": "/assets/art/glossary/sync.a51558aa93.webp",
  "sync-message": "/assets/art/glossary/binary-tree.d821ff3886.webp",
  "synthetic-event": "/assets/art/glossary/classlist.193c115861.webp",
  "system-call": "/assets/art/glossary/cd.b0b2eee179.webp",
  "system-diagram": "/assets/art/glossary/bucket-policy.a7301f9b43.webp",
  "table": "/assets/art/glossary/acid.49857c7fd6.webp",
  "team-development": "/assets/art/glossary/code-review.7f94e746e3.webp",
  "template": "/assets/art/glossary/browser.458bb73002.webp",
  "template-literal": "/assets/art/glossary/array.37407764f5.webp",
  "terminal": "/assets/art/glossary/cd.b0b2eee179.webp",
  "termination-condition": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "terminator": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "ternary-operator": "/assets/art/glossary/comparison-operator.bdb3627a93.webp",
  "test": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "thread": "/assets/art/glossary/process.267f3e1038.webp",
  "time-complexity": "/assets/art/glossary/binary-tree.d821ff3886.webp",
  "time-perf-counter": "/assets/art/glossary/comprehension.1d60a268b5.webp",
  "timestamp": "/assets/art/glossary/acid.49857c7fd6.webp",
  "token": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "tool-calling": "/assets/art/glossary/agent-harness.8b5a8f1e63.webp",
  "traceback": "/assets/art/glossary/csv-parse.0d1381423e.webp",
  "tracing": "/assets/art/glossary/cache.e2767a1b26.webp",
  "tradeoff": "/assets/art/glossary/tradeoff.c47509a634.webp",
  "transaction": "/assets/art/glossary/commit.16dbc8117a.webp",
  "transformer": "/assets/art/glossary/agent-skills.cf76d2c382.webp",
  "transparency": "/assets/art/glossary/border-radius.5eb96532ad.webp",
  "tree": "/assets/art/glossary/algorithm.12228a38d8.webp",
  "tree-structure": "/assets/art/glossary/binary-tree.d821ff3886.webp",
  "try-catch": "/assets/art/glossary/exception-handling.4a4ed8159a.webp",
  "try-except": "/assets/art/glossary/try-except.69944800ba.webp",
  "try-with-resources": "/assets/art/glossary/exception-handling.4a4ed8159a.webp",
  "tsconfig-json": "/assets/art/glossary/devdependencies.1f8be05b34.webp",
  "tuple": "/assets/art/glossary/mutable.f4139baa17.webp",
  "type-annotation": "/assets/art/glossary/react-reactnode.e84fe794b7.webp",
  "type-conversion": "/assets/art/glossary/argument.581d46da3f.webp",
  "type-hint": "/assets/art/glossary/comprehension.1d60a268b5.webp",
  "type-inference": "/assets/art/glossary/channel.d7617d2b58.webp",
  "type-safety": "/assets/art/glossary/react-reactnode.e84fe794b7.webp",
  "typescript": "/assets/art/glossary/react-reactnode.e84fe794b7.webp",
  "unsupervised-learning": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "url": "/assets/art/glossary/browser.458bb73002.webp",
  "usefetch": "/assets/art/glossary/hot-reload.49585d73db.webp",
  "uselocalstorage": "/assets/art/glossary/classname.61915cb878.webp",
  "validation": "/assets/art/glossary/arrow-function.0d549483ef.webp",
  "variable": "/assets/art/glossary/argument.581d46da3f.webp",
  "vector-database": "/assets/art/glossary/chunk.f73a92ccdb.webp",
  "vectorization": "/assets/art/glossary/chunk.f73a92ccdb.webp",
  "view": "/assets/art/glossary/acid.49857c7fd6.webp",
  "virtual-environment": "/assets/art/glossary/cross-validation.b44190d996.webp",
  "waterfall": "/assets/art/glossary/actor.0ae1cacf23.webp",
  "web-inf": "/assets/art/glossary/dependency-direction.db60ad2d8e.webp",
  "web-xml": "/assets/art/glossary/dependency-direction.db60ad2d8e.webp",
  "wireframe": "/assets/art/glossary/browser.458bb73002.webp",
  "workflow": "/assets/art/glossary/agent-loop.89e4cfe716.webp",
  "working-tree": "/assets/art/glossary/activation-bar.16a7e065f9.webp",
  "xss": "/assets/art/glossary/clickjacking.91f21ff47a.webp",
  "zero-downtime": "/assets/art/glossary/cache.e2767a1b26.webp",
  "zero-shot": "/assets/art/glossary/chain-of-thought.a3b3a34e8d.webp",
};
